var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',{style:([_vm.readOnly ? { backgroundColor: '#eee' } : { backgroundColor: '#fff' }]),attrs:{"value":_vm.tmpValue,"options":_vm.cmOptions},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }